import React, { Component } from 'react';
import BrandCard from '../component/BrandCard';
import { Grid, Row, Col } from 'react-bootstrap';
import {Helmet} from "react-helmet";

import base from '../rebase';

var _ = require('lodash');

var brandsDataOrginial = [
    {
        "name": "Black Teknigas",
        "image": "52f54c67890efed0d62a78d67be82ff5.jpg",
        "linkName": "Black-Teknigas",
        "desc": "Burner Controls",
        "desc_chi": "電索掣, 磁吸掣, 感應線, 火種掣, 控制氣體開關及溫度掣"
    },
    {
        "name": "Sensus",
        "linkName": "Sensus",
        "image": "63598a3e56489e2acb952d84a927574b.jpg",
        "desc": "Low Pressure Gas Flow Meter, Regulator",
        "desc_chi": "中,低壓氣體流量計, 調壓器",

    },
    {
        "name": "Bradford-White",
        "linkName": "Bradford-White",
        "image": "388f2f2a5221b0793f42d9471b83f5cc.jpg",
        "desc": "Commerical used Water Heater",
        "desc_chi": "商用燃氣熱水爐"
    },
    {
        "name": "Bock",
        "linkName": "Bock",
        "image": "89349e98e7978e8f69bdb6c4c2df6744.jpg",
        "desc": "Commerical Used Water Heater",
        "desc_chi": "商用高容量儲缸型熱水爐. 燃油 ,  燃氣兼用帶有水套設計	"
    },
    {
        "name": "Giuliani Anello",
        "linkName": "Giuliani-Anello",
        "image": "c1b8b19b63341e670da396c3134831ea.jpg",
        "desc": "Governor",
        "desc_chi": "低壓調壓器"
    },
    {
        "name": "ECII/Rego",
        "linkName": "ECII-Rego",
        "image": "6fb85ce1dc105163a2181b5fe78160ce.jpg",
        "desc": "Regulator, Valve",
        "desc_chi": "調壓器, 球閥, 角閥, 切斷閥, 過流閥, 止回閥, 安全閥, 拉斷伐, 閥門等"
    },
    {
        "name": "Corken",
        "linkName": "Corken",
        "image": "47228a5a1bf2d7e71e10c9c95fea9d42.jpg",
        "desc": "Gas Compressor",
        "desc_chi": "液化石油氣壓縮機"
    },
    {
        "name": "Rochester",
        "linkName": "Rochester",
        "image": "3320ea9d99c2ac9d3d08c7149dcf1fba.jpg",
        "desc": "Level Gauge",
        "desc_chi": "液位計"
    },
    {
        "name": "Jeavons (Elster)",
        "linkName": "Jeavons-(Elster)",
        "image": "ea9a63b18894ad318091c8ad40adc798.jpg",
        "desc": "Regulator",
        "desc_chi": "調壓器"
    },
    {
        "name": "Itokoki",
        "linkName": "Itokoki",
        "name_chi": "伊藤工機株式會所",
        "image": "db4a3cdacdc9ac65eeb2c066bd8fb395.jpg",
        "desc": "Regulator, Value, Rubber Hose, Automatic Change Over",
        "desc_chi": "高壓軟管, 高壓球閥, 高壓液體自動交換器, 調壓器,旋塞閥"
    },
    {
        "name": "Katsura",
        "linkName": "Katsura",
        "name_chi": "桂精機製作所株式會社",
        "image": "db0d5d34e684f2e266103ef482dd0918.jpg",
        "desc": "Regulator, Rubber Hose, Automatic Change Over, Pressure Gauge",
        "desc_chi": "高壓軟管, 調壓器, 壓力錶, 自動交換器"
    },
    {
        "name": "Kusaba",
        "linkName": "Kusaba",
        "image": "a92c1b94ce9d8c07905edaeab4d3b453.jpg",
        "desc": "Pressure Gauge",
        "desc_chi": "壓力錶"
    },
    {
        "name": "Xylem (Alcon)",
        "linkName": "Xylem-(Alcon)",
        "image": "f779a580d81afd12b61ab57f011fb712.jpg",
        "desc": "Valve",
        "desc_chi": "電索掣"
    },
    {
        "name": "Burkert",
        "linkName": "Burkert",
        "image": "f7b5de237a105dd92773925bce36e1c1.jpg",
        "desc": "Solenoid Valves",
        "desc_chi": "電索掣"
    },
    {
        "name": "R.U.B.",
        "linkName": "R.U.B",
        "image": "4bf5778c9aaeed48015c1bf915e31cb2.jpg",
        "desc": "Ball Valve",
        "desc_chi": "球閥"
    },
    {
        "name": "Kitz",
        "linkName": "Kitz",
        "image": "b26e9e9cb78b914fed63b02233e3ae14.jpg",
        "desc": "Ball Valve",
        "desc_chi": "球閥"
    },
    {
        "name": "Pentax",
        "linkName": "Pentax",
        "image": "84de1f1f2f1ed9bcea6c94562520ecd8.jpg",
        "desc": "Water Pump",
        "desc_chi": "水泵"
    },
    {
        "name": "Xylem (Totton)",
        "linkName": "Xylem-(Totton)",
        "image": "eeabdbf3035e8e35e9b98408a42da125.jpg",
        "desc": "Magnetic-Chemical-Pump",
        "desc_chi": "磁力化學泵"
    },
    {
        "name": "Maxitrol",
        "linkName": "Maxitrol",
        "image": "7d670bfe53ac259071c449cddf8ebf96.jpg",
        "desc": "Governor",
        "desc_chi": "Governor"
    },
    {
        "name": "Fujikoki",
        "linkName": "Fujikoki",
        "image": "7d670bfe53ac259071c449cddf8ebf96.jpg",
        "desc": "Regulator",
        "desc_chi": "Fujikoki"
    },
    {
        "name": "Econex",
        "linkName": "Econex",
        "image": "f739ea94799a4b0646850a5e9e204b68.jpg",
        "desc": "Safety Shut-off Valves",
        "desc_chi": "Safety Shut-off Valves"
    }
]


export default class Brand extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            brands: []
        };
    }
    init(){
        this.ref =  base.bindToState('brands', {
            context: this,
            state: 'brands',
            asArray: true
        });
    }

    componentDidMount() {
        this.init();
    }

    render() {       
        var brandList = this.state.brands.map(brand => <BrandCard key={brand.name} brand={brand} />);
        var metaBrandNames = _.map(this.state.brands, 'name').join(" "); //get all the brand name in one giant plain text        

        return (
            <div className="py-4 container">
                <Helmet>
                    <title>{'Preseli Engineering Supplies: View leading brands'}</title>
                    <meta name="description" content={'At Preseli we specalised in brands like ' + metaBrandNames}/>
                    <meta name="keywords" content={metaBrandNames}/>
                </Helmet>

                <h2 className="title-divider">{this.props.getTranslatedText("Brands")} <small></small></h2>
                <Row className="show-grid">{brandList}</Row>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Brand.js